import { Unique } from "../../../../shared/scripts/array-functions";
import { IFilter, InitializeFilterDropdown } from "../../../../shared/scripts/filtering";
import { getData } from "./site.utilities";

export class CTMSSiteCommunicationsSection implements IFilter {

    items: any[];
    itemsTable: any;
    tableSelector = '#communicationsTable';
    searchSelector = '#comm-search';
    clearSelector = '#comm-search-clear';

    url: string;
    showSiteColumn: boolean;

    constructor(handlerUrl: string, showSiteColumn = true){
        this.url = handlerUrl;
        this.showSiteColumn = showSiteColumn;

        this.initialize();
    }

    initialize() {
        this.itemsTable = $(this.tableSelector).DataTable({
            "dom": 'lrtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '200px',
            scrollCollapse: true,
            order: [[7, 'asc']],
            orderCellsTop: true,
            columns: [
                // { data:'Id', title: 'id', className: '' },
                { data:'Type', title: 'Type', className: '' },
                { data:'Category', title: 'Category', className: '' },
                { data: "Site", title: "Site", visible: this.showSiteColumn, render: (data) => Array.isArray(data) ? data.join(", ") : data },
                { data: "Study", title: "Study", render: (data) => Array.isArray(data) ? data.slice().sort().join(", ") : data },
                { data: "Significant", title: "Significant", render: (data) => data ? "Significant" : "" },
                { data: "Status", title: "Status" },
                { data: "CreatedBy", title: "Created By" },
                { data:'Date', title: 'Date', className: '' },
                {
                    data: null,
                    title: "",
                    className: "ctms-table-col-actions",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<button title="Edit"><i class="ctms-icon-pencil"></i></button>`;
                    }
                },
            ]
        });

        InitializeFilterDropdown('#comm-type', [], this);
        InitializeFilterDropdown('#comm-cat', [], this);
        InitializeFilterDropdown('#comm-study', [], this);
        InitializeFilterDropdown('#comm-createdby', [], this);

        $(this.searchSelector).on('input', (evt) => {
            $(this.tableSelector).DataTable().search(String($(evt.target).val() ?? '')).draw();
        });
        $(this.clearSelector).on('click', (evt) => {
            $ (this.searchSelector).val('');
            $(this.tableSelector).DataTable().search('').draw();
        });

    }

    async loadData() {
        $('#communicationsSectionLoading').removeClass('d-none');

        this.items = await getData(this.url);

        this.itemsTable.clear();
        this.itemsTable.rows.add(this.items).draw();

        const typeValues: string[] = Unique(this.items.map(c => c.Type), true).sort();
        $('#comm-type').empty();
        $('#comm-type').append(typeValues.map(e => new Option(e, e, false, true)));
        $('#comm-type').selectpicker("refresh");

        const categoryValues = Unique(this.items.map(c => c.Category), true).sort();
        $('#comm-cat').empty();
        $('#comm-cat').append(categoryValues.map(e => new Option(e, e, false, true)));
        $('#comm-cat').selectpicker("refresh");

        const studyValues = Unique(this.items.map(c => c.Study).flat(2), true).sort();
        $('#comm-study').empty();
        $('#comm-study').append(studyValues.map(e => new Option(e, e, false, true)));
        $('#comm-study').selectpicker("refresh");

        

        const createdByValues = Unique(this.items.map(c => c.CreatedBy).filter(v => v && v.trim() !== ''), true).sort();
        $('#comm-createdby').empty();
        $('#comm-createdby').append(createdByValues.map(e => new Option(e, e, false, true)));
        $('#comm-createdby').selectpicker("refresh");

        $('#communicationsSectionLoading').addClass('d-none');
    }

    triggerFilter() {
        const type = $('#comm-type').val() as [any];
        const category = $('#comm-cat').val() as [any];
        const study = $('#comm-study').val() as [any];
        const createdBy = $('#comm-createdby').val() as [any];

        const filteredItems = this.items.filter((c) => {
            const s = study.filter((ss) => c.Study.includes(ss));
            return type.includes(c.Type) && category.includes(c.Category) && s.length > 0 && createdBy.includes(c.CreatedBy);
        });

        this.itemsTable.clear();
        this.itemsTable.rows.add(filteredItems).draw();
    }

    resetFilters() {
        $('#comm-type').selectpicker('selectAll');
        $('#comm-type').selectpicker('refresh');

        $('#comm-cat').selectpicker('selectAll');
        $('#comm-cat').selectpicker('refresh');

        $('#comm-study').selectpicker('selectAll');
        $('#comm-study').selectpicker('refresh');

        $('#comm-createdby').selectpicker('selectAll');
        $('#comm-createdby').selectpicker('refresh');

        this.itemsTable.clear();
        this.itemsTable.rows.add(this.items).draw();
    }
}